import { Body, Checkbox } from '@hover/blueprint';
import React from 'react';

import { FeatureTracking } from 'src/shared/constants/FeatureFlag';
import {
  TranslationNamespace,
  useCurrentPage,
  useTranslate,
} from 'src/shared/hooks';
import { checkboxToggled } from 'src/shared/telemetry';

import { useRenderingContext } from '../../hooks';

const ConsentCheckbox = ({
  isChecked,
  onChange,
  testId,
  reShare = false,
}: {
  isChecked: boolean;
  onChange: () => void;
  testId?: string;
  reShare?: boolean;
}) => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const currentPage = useCurrentPage();
  const { trackingData } = useRenderingContext();
  const defaultTrackingProperties = {
    ...trackingData,
    page_or_screen_name: currentPage ?? '',
    primary_cta: false,
    feature: FeatureTracking.RENDERING,
  };
  const handleChange = () => {
    checkboxToggled({
      ...defaultTrackingProperties,
      checked: !isChecked,
      track_id: reShare ? 'rendering-share-consent' : 'rendering-consent',
    });
    onChange();
  };
  return (
    <Checkbox
      aria-label="consentCheckbox"
      isChecked={isChecked}
      marginBottom={400}
      onChange={handleChange}
    >
      <Body fontSize={200} marginY={0} testId={testId}>
        {t('renderings.consentCheckBox')}
      </Body>
    </Checkbox>
  );
};

export { ConsentCheckbox };
